import { Ajax2 } from '@shared/Ajax';

export const PdfReportService = {
    fetch: (templateId: number): Promise<IReportTemplate> => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/report-template/${templateId}`,
            method: 'GET',
        }).then(resp => resp.template);
    },

    fetchAll: (projectId: number): Promise<IReportTemplate[]> => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/report-templates.json`,
            method: 'GET',
            data: {
                projectId,
            }
        }).then(resp => resp.templates)
    },

    create: (projectId: number, data: IReportTemplate) => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/report-template`,
            method: 'POST',
            contentType: 'json',
            data: {
                name: data.name,
                document: { id: data.id },
                project: { id: projectId },
            }
        });
    },

    remove: (templateId: number) => {
        return Ajax2({
            url: kuura.getContextPath() + `/api/1/report-template?templateId=${templateId}`,
            method: 'DELETE',
        });
    },
};
